var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useRef, useEffect } from 'react';
import * as Utils from './utils';
const isSSR = typeof window === 'undefined';
const loadImg = (src, canvas) => __awaiter(void 0, void 0, void 0, function* () {
    const imgData = yield Utils.loadImgData(src);
    const dataURL = yield Utils.decode(imgData, canvas);
    return dataURL;
});
const Img = React.memo((_a) => {
    var _b;
    var { src } = _a, args = __rest(_a, ["src"]);
    const webpRegexp = args.webpRegexp || /(_webp)|(.webp$)/g;
    if (isSSR || !Utils.isWebp(src) || ((_b = window.__IFENG_ENV__) === null || _b === void 0 ? void 0 : _b.supportWebp)) {
        // 原生支持 webp 格式
        return React.createElement("img", Object.assign({ src: src }, args));
    }
    else if (Utils.isWebp(src) && typeof WebAssembly == 'undefined' && !args.force) {
        // 使用非 webp 格式
        return React.createElement("img", Object.assign({ src: src.replace(webpRegexp, '') }, args));
    }
    const [dataURL, setDataURL] = useState('');
    const cvRef = useRef(null);
    useEffect(() => {
        loadImg(src, cvRef.current).then(setDataURL);
    }, []);
    // 使用 wasm 或者前端解码 webp
    return (React.createElement(React.Fragment, null,
        React.createElement("img", Object.assign({ src: dataURL }, args)),
        React.createElement("canvas", { ref: cvRef, style: { display: 'none' } })));
});
export default Img;
